import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function WorldPreview() {
  const { slug } = useParams();
  const [world, setWorld] = useState(null);

  useEffect(() => {
    api.getWorld(slug).then((r) => {
      setWorld(r.data);
      const cat = r.data.catalog || {};
      document.title = `${cat.name || r.data.name} – náhled světa | Svatební světy`;
    }).catch(() => {});
  }, [slug]);

  const cat = world?.catalog || {};

  return (
    <div className="min-h-screen bg-[#0B0908] text-[#F2EAD9]">
      <nav className="fixed top-0 z-40 flex w-full items-center justify-between border-b border-[#2E271C] bg-[#0B0908]/85 px-6 py-4 backdrop-blur-xl">
        <Link
          to="/"
          data-testid="preview-back-btn"
          className="flex items-center gap-2 rounded-full border border-[#2E271C] px-4 py-2 text-sm text-[#F2EAD9]/80 transition-colors hover:border-[#C9A961] hover:text-[#C9A961]"
        >
          <ArrowLeft size={16} /> Zpět
        </Link>
        <span className="hidden font-heading text-sm uppercase tracking-widest text-[#9C917E] sm:block">
          Náhled světa
        </span>
        <a
          href="/#objednat"
          data-testid="preview-order-btn"
          className="rounded-full bg-[#C9A961] px-5 py-2 text-sm font-medium text-[#0B0908] transition-colors hover:bg-[#DEC182]"
        >
          Chci tento svět
        </a>
      </nav>

      <div className="mx-auto max-w-6xl px-6 pb-20 pt-28">
        <div className="mb-10 text-center">
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.3em] text-[#C9A961]">Ukázka náhledu</p>
          <h1 className="font-heading text-4xl sm:text-5xl">{cat.name || ""}</h1>
          <p className="mt-3 text-[#9C917E]">{cat.tagline || ""}</p>
          <p className="mx-auto mt-4 max-w-xl text-sm text-[#9C917E]/80">
            Toto je pouze ukázka úvodní části světa. Kompletní web se všemi animovanými sekcemi
            (pozvánka, příběh, menu, program, zasedací pořádek) dostanete po objednání.
          </p>
        </div>

        <div className="flex flex-col items-center justify-center gap-10 lg:flex-row lg:items-end">
          {/* Desktop browser mockup */}
          <div className="w-full max-w-3xl" data-testid="desktop-mockup">
            <div className="overflow-hidden rounded-xl border border-[#2E271C] bg-[#141109] shadow-[0_30px_80px_rgba(0,0,0,.6)]">
              <div className="flex items-center gap-2 border-b border-[#2E271C] bg-[#1A1610] px-4 py-3">
                <span className="h-3 w-3 rounded-full bg-[#e2574c]" />
                <span className="h-3 w-3 rounded-full bg-[#e0b13e]" />
                <span className="h-3 w-3 rounded-full bg-[#57b25e]" />
                <div className="ml-3 flex-1 rounded-full bg-[#0B0908] px-4 py-1.5 text-xs text-[#9C917E]">
                  vase-svatba.cz
                </div>
              </div>
              <div className="relative h-[560px] overflow-hidden">
                <iframe
                  title="Náhled světa"
                  data-testid="world-preview-iframe"
                  src={api.previewUrl(slug)}
                  className="origin-top-left border-0"
                  style={{ width: 1440, height: 1073, transform: "scale(0.522)" }}
                />
              </div>
            </div>
            <p className="mt-3 text-center text-xs uppercase tracking-[0.2em] text-[#9C917E]/70">Náhled v prohlížeči</p>
          </div>

          {/* Phone mockup */}
          <div className="shrink-0" data-testid="phone-mockup">
            <div className="relative w-[240px] overflow-hidden rounded-[2.4rem] border-[6px] border-[#2A241C] bg-[#141109] shadow-[0_30px_80px_rgba(0,0,0,.6),0_0_40px_rgba(201,169,97,.08)]">
              <div className="absolute left-1/2 top-2 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-[#0B0908]" />
              <div className="relative h-[470px] overflow-hidden">
                <iframe
                  title="Mobilní náhled"
                  data-testid="phone-mockup-iframe"
                  src={api.previewUrl(slug)}
                  className="pointer-events-none origin-top-left border-0"
                  style={{ width: 390, height: 800, transform: "scale(0.585)" }}
                  scrolling="no"
                />
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-[#141109] to-transparent" />
              </div>
            </div>
            <p className="mt-3 text-center text-xs uppercase tracking-[0.2em] text-[#9C917E]/70">Náhled v telefonu</p>
          </div>
        </div>

        <div className="mt-14 text-center">
          <a
            href="/#objednat"
            data-testid="preview-order-cta"
            className="inline-flex items-center gap-2 rounded-full bg-[#C9A961] px-10 py-4 text-sm font-medium uppercase tracking-widest text-[#0B0908] transition-all hover:bg-[#DEC182] hover:shadow-[0_0_35px_rgba(201,169,97,.4)]"
          >
            Objednat tento svět za 9 999 Kč <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </div>
  );
}
